import { useEffect, useState } from 'react';
import { Save, FolderDown, X } from 'lucide-react';

// Reusable "Save As…" dialog (mirrors the Map Editor UX): shows the auto-generated
// base name, lets the user append a custom name, then pick the destination folder.
export const SaveAsDialog = ({ open, title = 'Save As…', defaultName, folderNote, onCancel, onSave }) => {
  const base = (defaultName || 'dump.bin').replace(/\.bin$/i, '');
  const [suffix, setSuffix] = useState('');
  useEffect(() => { if (open) setSuffix(''); }, [open, defaultName]);
  if (!open) return null;
  const finalName = (base + (suffix || '')).trim().replace(/\.bin$/i, '') + '.bin';
  const doSave = () => onSave(finalName);
  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/70 backdrop-blur-sm p-4" data-testid="saveas-dialog">
      <div className="w-full max-w-md rounded-xl border border-slate-700 bg-[#0c1017] p-5 shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-2 mb-4">
          <FolderDown className="h-5 w-5 text-[#f05a58]" />
          <h3 className="font-head font-bold text-white uppercase text-base">{title}</h3>
          <button data-testid="saveas-close" onClick={onCancel} className="ml-auto p-1 rounded hover:bg-white/10 text-slate-400 hover:text-white"><X className="h-4 w-4" /></button>
        </div>
        <label className="block text-[11px] uppercase tracking-widest text-slate-500 mb-1">Nama tambahan (ditaruh setelah nama asli)</label>
        <div className="flex items-center rounded-lg border border-slate-700 bg-[#121824] overflow-hidden">
          <span className="px-2.5 py-2 text-sm font-mono-tt text-slate-500 border-r border-slate-700 truncate max-w-[55%]" title={base}>{base}</span>
          <input data-testid="saveas-input" autoFocus value={suffix} onChange={(e) => setSuffix(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') doSave(); if (e.key === 'Escape') onCancel(); }}
            placeholder="_backup" className="flex-1 min-w-0 bg-transparent px-2 py-2 text-sm font-mono-tt text-slate-100 outline-none" />
        </div>
        <div className="mt-3 text-[11px] text-slate-500">File akhir: <span data-testid="saveas-preview" className="font-mono-tt text-[#f05a58]">{finalName}</span></div>
        <p className="mt-2 text-[11px] text-slate-600">{folderNote || 'Anda akan memilih folder tujuan di dialog berikutnya (browser/aplikasi yang mendukung). Jika tidak, file diunduh ke folder default.'}</p>
        <div className="mt-5 flex items-center gap-2 justify-end">
          <button data-testid="saveas-cancel" onClick={onCancel} className="px-4 py-2 rounded bg-slate-800 hover:bg-slate-700 text-slate-100 font-semibold text-sm">Batal</button>
          <button data-testid="saveas-confirm" onClick={doSave} className="inline-flex items-center gap-1.5 px-4 py-2 rounded bg-[#e52321] hover:bg-[#c81e1c] text-white font-bold text-sm"><Save className="h-4 w-4" /> Pilih folder &amp; Simpan</button>
        </div>
      </div>
    </div>
  );
};
